// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1hu8K","buttons":"Footer_buttons__2UQZP"};